import { RequisitionCardComponent } from "./requisition-card.component";
export var RequisitionCardModule = angular
    .module('requisitionCard', [])
    .component(RequisitionCardComponent.selector, RequisitionCardComponent.component)
    .name;
//# sourceMappingURL=requisition-card.module.js.map